import { render, staticRenderFns } from "./EditAntiPassBack.vue?vue&type=template&id=ec1e38fa&scoped=true"
import script from "./EditAntiPassBack.vue?vue&type=script&lang=js"
export * from "./EditAntiPassBack.vue?vue&type=script&lang=js"
import style0 from "./EditAntiPassBack.vue?vue&type=style&index=0&id=ec1e38fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1e38fa",
  null
  
)

export default component.exports